import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import withTranslations from '../../../common/components/utils/Translations/withTranslations';
import translatePropTypes from '../../../common/translatePropTypes';

@withTranslations
export default class PasswordExpirationInfo extends React.PureComponent {
  static propTypes = {
    expiresAt: PropTypes.string.isRequired,
    ...translatePropTypes,
  };
  render() {
    const { expiresAt, t } = this.props;
    const expirationDate = moment(expiresAt);
    return (
      <div className="form-group form-group-material">
        <span>
          {t('Current password expires on #{date} - #{years} left', {
            date: expirationDate.format('ll'),
            years: expirationDate.fromNow('d'),
          })}
        </span>
      </div>
    );
  }
};
